import { useRef, useState, useCallback } from 'react';
import { useUploadPhoto } from '@/hooks/api/usePhotos';
import { useCBSBatchStore } from '@/stores/cbsBatchStore';
import type { Database } from '@/integrations/supabase/types';

type PhotoCategory = Database['public']['Enums']['photo_category'];

export const useInlineCamera = (category: PhotoCategory) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [photoTaken, setPhotoTaken] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const uploadPhoto = useUploadPhoto();
  const activeBatch = useCBSBatchStore((s) => s.activeBatch);

  const openCamera = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleFileSelected = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if ('vibrate' in navigator) navigator.vibrate(15);
    setIsUploading(true);

    try {
      await uploadPhoto.mutateAsync({
        file,
        photoCategory: category,
        batchId: activeBatch?.id,
      });
      setPhotoTaken(true);
    } catch {
      // Error toast handled by useUploadPhoto
    } finally {
      setIsUploading(false);
      e.target.value = '';
    }
  }, [category, activeBatch?.id, uploadPhoto]);

  return { fileInputRef, photoTaken, isUploading, openCamera, handleFileSelected };
};
